import React from 'react';
import { useFormContext } from 'react-hook-form';

export default function Description() {
  const { watch } = useFormContext();
  const description = watch('form_description') || 'Add description';
  return (
    <p className="form-desc" style={{ textAlign: 'justify' }}>
      {description}
    </p>
  );
}
